import { supabase } from '../supabase';
import { getOpenAIInstance } from '../openai';

export async function analyzeExpensePatterns(expenses: any[]) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Analyze expense patterns to identify trends, anomalies, and opportunities for cost reduction. Provide insights in a clear, actionable format.',
      },
      {
        role: 'user',
        content: `Analyze these expenses and provide insights: ${JSON.stringify(expenses)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
  });

  return completion.choices[0].message.content;
}

export async function categorizePurchases(expenses: any[]) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Categorize expenses into business categories and determine tax deductibility. Return structured JSON with categories and reasoning.',
      },
      {
        role: 'user',
        content: `Categorize these expenses: ${JSON.stringify(expenses)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
    response_format: { type: 'json_object' },
  });

  return JSON.parse(completion.choices[0].message.content);
}

export async function generateExpenseReport(expenses: any[], timeframe: string) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Generate a detailed expense report with summaries by category, trends, and recommendations.',
      },
      {
        role: 'user',
        content: `Generate an expense report for timeframe ${timeframe} with this data: ${JSON.stringify(expenses)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
  });

  return completion.choices[0].message.content;
}
